/**
 * Client-side gate for Assessment Orchestration UI (AO-1.15 / AD-20).
 * Mirrors backend ASSESSMENT_ORCHESTRATION_ENABLED — fail closed.
 *
 * Hides navigation and blocks the route shell; does not authorize.
 * Server still answers 404 when the deployment flag / feature is off.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/** @returns {boolean} */
export function isAssessmentOrchestrationUiEnabled() {
  return parseEnvFlag(process.env.REACT_APP_ASSESSMENT_ORCHESTRATION_ENABLED);
}

/**
 * AMI programme UI gate (AMI-2.3 AC-13). Fail closed; never widens past
 * orchestration. Flag off ⇒ Monitoring wizard step absent.
 *
 * @returns {boolean}
 */
export function isAssessmentMonitoringUiEnabled() {
  if (!isAssessmentOrchestrationUiEnabled()) return false;
  return parseEnvFlag(process.env.REACT_APP_ASSESSMENT_MONITORING_ENABLED);
}

/**
 * AMI review-queue UI gate (AMI-6.1 / AMI-4.3). Fail closed; never widens
 * past assessment_monitoring.
 *
 * @returns {boolean}
 */
export function isAssessmentMonitoringQueueUiEnabled() {
  if (!isAssessmentMonitoringUiEnabled()) return false;
  return parseEnvFlag(process.env.REACT_APP_ASSESSMENT_MONITORING_QUEUE_ENABLED);
}

/**
 * AMI analytics UI gate (AMI-7.1). Fail closed; never widens past monitoring.
 *
 * @returns {boolean}
 */
export function isAssessmentMonitoringAnalyticsUiEnabled() {
  if (!isAssessmentMonitoringUiEnabled()) return false;
  return parseEnvFlag(process.env.REACT_APP_ASSESSMENT_MONITORING_ANALYTICS_ENABLED);
}

/** AO-11.3 — faculty close / override / publication. Fail closed. */
export function isAssessmentOperationsUiEnabled() {
  if (!isAssessmentOrchestrationUiEnabled()) return false;
  return parseEnvFlag(process.env.REACT_APP_ASSESSMENT_OPERATIONS_ENABLED);
}
